import { render, staticRenderFns } from "./PodcastSupport.vue?vue&type=template&id=1b907dc4&"
import script from "./PodcastSupport.vue?vue&type=script&lang=js&"
export * from "./PodcastSupport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports